// extracted by mini-css-extract-plugin
export default {"header":"Ge197d8","headerTitle":"G9c5902","headerCta":"Ge77956","currentValue":"Ga17995"};